import React from 'react'
import { RouteComponentProps } from 'wouter'

import { buildComponent } from '../../../components/factory'

import * as UI from '@mantine/core'
import * as Components from './components'

export const ScreenConnectedCategoriesEdit = buildComponent<
  RouteComponentProps<{ categoryId: string }>
>().withRender(({ props }) => (
  <React.Fragment>
    <Components.Title categoryId={props.params.categoryId} />

    <UI.Stack sx={{ maxWidth: 1280, margin: '2rem auto 32rem' }} spacing={32}>
      <UI.Card shadow="sm" pb={32} px={24} sx={{ position: 'relative' }}>
        <Components.SectionMain categoryId={props.params.categoryId} />
      </UI.Card>

      <UI.Card shadow="sm" pb={32} px={24} sx={{ position: 'relative' }}>
        <Components.SectionImage categoryId={props.params.categoryId} />
      </UI.Card>

      <UI.Card shadow="sm" pb={32} px={24} sx={{ position: 'relative' }}>
        <Components.SectionDelete categoryId={props.params.categoryId} />
      </UI.Card>
    </UI.Stack>
  </React.Fragment>
))
